import CVForm from "component/employeeProfile/cvForm";
import{ memo } from "react";

const EmployeeCreateCVPage = () =>{
    return (
        <CVForm/>
    );
}

export default memo(EmployeeCreateCVPage);